import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem } from "@mui/material";
import { Route, Routes } from 'react-router-dom'
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../redux/slice/user";
import api from "../../API";
import GroupIcon from '@mui/icons-material/Group';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import RuleIcon from '@mui/icons-material/Rule';
import TranslateIcon from '@mui/icons-material/Translate';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { SearchBackDrop } from "../component/common/SearchBackDrop";

interface UseCheckCntType {
  t_cnt: number;
  c_cnt: number;
  f_cnt: number;
}

const initailData_use_check: UseCheckCntType = {
  t_cnt: 0,
  c_cnt: 0,
  f_cnt: 0
};

const SsbWorkerPage = (props:any) => {

  const dispatch = useDispatch();

  const nav = useNavigate();

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  let ssb_role = auth.user.roles.some((obj:any) => ['SSB','SSB_PRC'].includes(obj.role));

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)
 
  const getAuth = async () => {
    if(!email){ nav('/') }
    api.get('/@me',{params:{email:email}})
    .then((resp:any) => {dispatch(setUserInfo(resp.data)); console.log('/@me',resp.data) })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }


  useEffect(() => {
    getAuth()
  },[])

  return (
    <Box>
      <Box sx={{ backgroundColor: "#fff", height: "100%", maxWidth: "100%" }}>
        {/* <Box sx={{textAlign: "center", paddingTop:"20px"}}><img style={{width:"120px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/sw_flag.jpg'} /></Box> */}
        <Box sx={{fontSize:"60px", textAlign: "center", padding: "5px 20px 20px 20px"}}>2026 사회적 안전성 벤치마크 데이터</Box>
        {/* <Box sx={{display:"flex", justifyContent: "center", marginTop:"100px"}}> */}
        <Box>
          <Box sx={{display:"flex", justifyContent: "center", marginTop:"100px"}}>
          {/* {["EVAL001", "EVAL002","EVAL003","EVAL004","EVAL006","EVAL007","EVAL022","EVAL023","EVAL024"].includes(worker) &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#555fb6", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=> nav('evkn-category')}>
              지식-카테고리 검수
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          } */}
          {/* {ssb_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#b65586", color: "#fff", "&:hover": { background: "#da51da",color: "#fff"}}} variant="contained" onClick={()=> nav('prc')}>
              가공
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          } */}
          {/* {ssb_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#b6b455", color: "#fff", "&:hover": { background: "#daa351",color: "#fff"}}} variant="contained" onClick={()=> nav('isp')}>
              검수
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          } */}
          {/* {ssb_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#b6b455", color: "#fff", "&:hover": { background: "#daa351",color: "#fff"}}} variant="contained" onClick={()=> nav('isp-mcq')}>
              객관식
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          } */}
          {ssb_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#b6b455", color: "#fff", "&:hover": { background: "#daa351",color: "#fff"}}} variant="contained" onClick={()=> nav('isp-mcq-v2')}>
              객관식
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {ssb_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#55b6b6", color: "#fff", "&:hover": { background: "#51daac",color: "#fff"}}} variant="contained" onClick={()=> nav('isp-saq')}>
              단답형
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {ssb_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#da51da", color: "#fff", "&:hover": { background: "#51daac",color: "#fff"}}} variant="contained" onClick={()=> nav('isp-ess')}>
              서술형
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          </Box>
          
        </Box>
        
      </Box>

    </Box>
  );
};

export default SsbWorkerPage;
